import { SellerUnitsAndProjectsOne } from "@/types/sup";
import { toSentenceCase } from "@/utils/string/to-sentence-case";

interface FlooringProps {
	supOne: SellerUnitsAndProjectsOne;
}

export function Flooring({ supOne }: FlooringProps) {
	const flooring = supOne.spaceSummary?.flooring || [];

	if (!flooring.length) {
		return null;
	}

	return (
		<div>
			{flooring.map((item, index) => (
				<div key={index} className="flex justify-between items-center gap-4 py-1.5 px-2 border-b border-gray-200">
					<span className="text-sm font-medium text-gray-600">{item.name}</span>
					<div className="flex items-center gap-1">
						<span className="text-sm font-semibold text-right">
							{flooring.length === 1 ? "Everywhere" : (item.space || []).map(toSentenceCase).join(", ")}
						</span>
					</div>
				</div>
			))}
		</div>
	);
}
